import { TagProps } from "@chakra-ui/react";
import {
  brandStyles, grayStyles, orangeStyles,
} from "components/Tag/Status/styles";
import BaseActionStatus from "components/Tag/Status/BaseActionStatus";
import { NewHireJourney } from "models/v2/newHireJourney";

function newHireJourneyStatusStyles(status: NewHireJourney["status"] | undefined) {
  switch (status) {
    case "pending":
      return grayStyles;
    case "upcoming":
      return orangeStyles;
    case "active":
      return brandStyles;
    case "archived":
      return grayStyles;
    default:
      return {};
  }
}

function newHireJourneyStatusText(status: NewHireJourney["status"] | undefined) {
  switch (status) {
    case "pending":
      return "Pending";
    case "upcoming":
      return "Upcoming";
    case "active":
      return "In Progress";
    case "archived":
      return "Past";
    default:
      return "loading...";
  }
}

interface NewHireJourneyStatusProps extends TagProps {
  newHireJourney: NewHireJourney | undefined;
}

export default function NewHireJourneyStatus({ newHireJourney, ...rest }: NewHireJourneyStatusProps) {
  return (
    <BaseActionStatus {...(newHireJourneyStatusStyles(newHireJourney?.status))} {...rest}>
      {newHireJourneyStatusText(newHireJourney?.status)}
    </BaseActionStatus>
  );
}
